import { render, staticRenderFns } from "./tuzhuanglinxiMb.vue?vue&type=template&id=77e969f8&scoped=true&"
import script from "./tuzhuanglinxiMb.vue?vue&type=script&lang=js&"
export * from "./tuzhuanglinxiMb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e969f8",
  null
  
)

export default component.exports